import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router =  new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      meta: {index:0},
      component: resolve => require(['@/views/login'], resolve)
    },
    {
      path: '/wxLoginFail',
      name: 'wxLoginFail',
      meta: {index:0},
      component: resolve => require(['@/views/wxLoginFail'], resolve)
    },
    {
      path: '/main',
      name: 'Main',
      meta: {index:1},
      component: resolve => require(['@/views/main'], resolve),
      children:[
        {
          path: '/',
          name: 'Hospital',
          component: resolve => require(['@/components/hospital'], resolve),
          meta : {
            requireAuth : true,
            index:1
          }
        },
        {
          path: '/Myself',
          name: 'Myself',
          component: resolve => require(['@/components/myself'], resolve),
          meta : {
            requireAuth : true,
            index:1
          }
        },
        {
          path: '/visit',
          name: 'Visit',
          component: resolve => require(['@/components/visit'], resolve),
          meta : {
            requireAuth : true,
            index:1
          }
        },
        {
          path: '/commonRecipe',
          name: 'commonRecipe',
          component: resolve => require(['@/components/commonRecipe'], resolve),
          meta : {
            requireAuth : true,
            index:2
          }
        },
        {
          path: '/editPrescription',
          name: 'editPrescription',
          component: resolve => require(['@/components/editPrescription'], resolve),
          meta : {
            requireAuth : true,
            index:3
          }
        },
        {
          path:'/order',
          name:'Order',
          component: resolve => require(['@/components/order'], resolve),
          meta : {
            requireAuth : true,
            index:2
          }
        },
        {
          path: '/recipeDetail',
          name: 'recipeDetail',
          component: resolve => require(['@/components/recipeDetail'], resolve),
          meta : {
            requireAuth : true,
            index:3
          }
        },
        {
          path: '/makeRecipe',
          name: 'makeRecipe',
          component: resolve => require(['@/components/makeRecipe'], resolve),
          meta : {
            requireAuth : true,
            index:2
          }
        },
        {
          path: '/videoPlay',
          name: 'videoPlay',
          component: resolve => require(['@/components/videoPlay'], resolve),
          meta : {
            requireAuth : true,
            index:3
          }
        },
        {
          path: '/liveRoom',
          name: 'liveRoom',
          component: resolve => require(['@/components/liveRoom'], resolve),
          meta : {
            requireAuth : true,
            index:2
          }
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if(savedPosition) {
      return savedPosition
    }else{
      return { x: 0, y: 0 }
    }
  }
})
/*路由拦截*/
router.beforeEach((to, from, next) => {
  //to and from are both router objects
  // 判断是否需要登录权限 如有需进一步验证
  if (to.path) {
    _hmt.push(['_trackPageview', '/#' + to.fullPath]);
  };
  if(window.location.href.indexOf('token')>=0){
    const middoctorToken = JSON.stringify(window.location.href.split("token=")[1]); 
    sessionStorage.setItem('doctorToken', middoctorToken);
  } 
  if(to.matched.some(res => res.meta.requireAuth)){
    // 判断是否登录
    if(sessionStorage.getItem('doctorToken')) {
      next();
    }else {
      // 没登录则跳转登录页面
      next({
        path:'/'
      })
    }
  }else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js